import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

const Category = () => {
  return (
    <SettingsMetaData propertyName={"category_Customer"} viewPropertyName={"Category"} />

  )
}

export default Category